const mixins = {};

export default mixins;
